import React, { Children } from 'react';
import { motion } from 'framer-motion';
import { X } from 'lucide-react';
const approaches = ['Los geles anestésicos comerciales han sido advertidos por la FDA por riesgos en la oxigenación de la sangre.', 'Los baños de agua fría para la fiebre causan choques térmicos y estrés innecesario en el bebé.', 'Bajar la fiebre de inmediato impide que el sistema inmune aprenda a defenderse por sí mismo.', "Esperar a que el niño 'simplemente se calme' solo aumenta el agotamiento de toda la familia."];
const containerVariants = {
  hidden: {
    opacity: 0
  },
  visible: {
    opacity: 1,
    transition: {
      staggerChildren: 0.2
    }
  }
};
const itemVariants = {
  hidden: {
    opacity: 0,
    x: -20
  },
  visible: {
    opacity: 1,
    x: 0,
    transition: {
      duration: 0.5
    }
  }
};
export function FailedApproaches() {
  return <section className="py-16 md:py-24 bg-cream-dark/50" data-id="element-23">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-24">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 0.6
      }} className="text-center mb-12" data-id="element-25">
          <h2 className="text-3xl md:text-4xl font-bold mb-4" data-id="element-26">
            Lo que ya intentaste y no funcionó
          </h2>
          <div className="w-24 h-1 bg-terracotta/30 mx-auto rounded-full" data-id="element-27"></div>
        </motion.div>

        <motion.ul variants={containerVariants} initial="hidden" whileInView="visible" viewport={{
        once: true,
        margin: '-50px'
      }} className="space-y-6" data-id="element-28">
          {approaches.map((approach, index) => <motion.li key={index} variants={itemVariants} className="flex items-start bg-white/60 p-6 rounded-xl shadow-sm border border-cream-dark" data-id="element-29">
              <div className="flex-shrink-0 mt-1" data-id="element-30">
                <div className="w-8 h-8 rounded-full bg-terracotta/10 flex items-center justify-center" data-id="element-31">
                  <X className="w-5 h-5 text-terracotta" data-id="element-32" />
                </div>
              </div>
              <p className="ml-4 text-lg text-brown-body leading-relaxed" data-id="element-33">
                {approach}
              </p>
            </motion.li>)}
        </motion.ul>
      </div>
    </section>;
}